import { ethereum } from '@0xtorch/core'
import { arbitrumNova } from 'viem/chains'
import type { Client } from '../../client'
import { createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createBlockscout } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

// Etherscan v2 の対応チェーンから外れたため Blockscout を利用する
export const createArbitrumNovaChain = ({
  explorerProxyUrl: proxyUrl,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createArbitrumNovaChainCustom({
    client: createClient({
      chain: arbitrumNova,
      httpRpcs: arbitrumNovaHttpRpcs,
    }),
    explorer: createBlockscout({
      useAddressApiV2: true,
      name: 'Arbitrum Nova Blockscout',
      baseUrl: 'https://arbitrum-nova.blockscout.com',
      apiBaseUrl: 'https://arbitrum-nova.blockscout.com/api',
      proxyUrl,
    }),
  })

type CreateArbitrumNovaChainCustomParameters = {
  client: Client
  explorer: Explorer
}

export const createArbitrumNovaChainCustom = ({
  client,
  explorer,
}: CreateArbitrumNovaChainCustomParameters): Chain => ({
  id: 42_170,
  network: 'arbitrum-nova',
  name: 'Arbitrum Nova',
  nativeToken: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    currency: ethereum,
  },
  wrappedTokenAddresses: new Set([
    '0x722e8bdd2ce80a4422e880164f2079488e115365',
  ]),
  explorer,
  client,
  blockTime: undefined,
  coingeckoId: 'arbitrum-nova',
  defillamaId: undefined,
})

export const arbitrumNovaHttpRpcs: HttpRpc[] = [
  {
    url: 'https://nova.arbitrum.io/rpc',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://arbitrum-nova-rpc.publicnode.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://arbitrum-nova.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://arb-nova-mainnet.gateway.tatum.io',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://docs-demo.nova-mainnet.quiknode.pro',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const arbitrumNovaWebsocketRpcUrls: string[] = [
  'wss://arbitrum-nova-rpc.publicnode.com',
]
